import { createContext } from "reka-ui";

interface MenuRadioGroupContext {
  currentValue: () => string;
  select: (value: string) => void;
}

export const [injectRadioGroup, provideRadioGroup] =
  createContext<MenuRadioGroupContext>("MenuRadioGroup");
